import { StorageManager, storageKey } from '_c/business/storage';
import {
  ChannelBaseInfo,
  GroupInfo,
  GroupUserInfo,
  ChanCateBaseInfo,
  AdvConfList,
  EntranceConfList,
  TopicInfo,
  ABTestReportInfo,
  GroupBaseInfo,
} from '_c/typings/proto';
import { IMsg } from '_c/typings/model/im';

export interface IGroupCategoryInfo {
  id: string,
  name: string,
  channelList: Array<ChannelBaseInfo>
}

export interface GroupInfoExtension extends GroupInfo {
  isUpdate?: boolean,
  currentUserInfo?: GroupUserInfo,
  /** 是否是预览中 */
  isPreview?: boolean,
}

export interface State {
  groupList: GroupInfoExtension[];
  channelList: Record<string, Array<ChannelBaseInfo>>;
  channelListWithCategory: Record<string, Array<IGroupCategoryInfo>>;
  selectGroupId: string;
  selectChannelId: string;
  lastMessageList: Record<string, Record<string, IMsg>>;
  atMeList: Record<string, Record<string, number>>;
  atCountList: Record<string, Record<string, number>>;
  unreadCountList: Record<string, Record<string, number>>;
  isUpdateGroupInfo: Record<string, boolean>;
  promotionList: Record<string, AdvConfList>;
  centerEntranceList: Record<string, EntranceConfList>;
  channelFoldData: Record<string, Array<ChanCateBaseInfo>>;
  topicList: Record<string, Record<string, Array<TopicInfo>>>;
  abTestReportInfoMap: Record<string, ABTestReportInfo|null>;
  welcomeGroupInfoMap: Record<string, GroupBaseInfo>;
  firstJoinMap: Record<string, boolean>;
}

const state: State = {
  groupList: [],
  channelList: {},
  channelListWithCategory: {},
  selectGroupId: '',
  selectChannelId: '',
  lastMessageList: {},
  atMeList: {},
  atCountList: {},
  unreadCountList: {},
  isUpdateGroupInfo: {},
  promotionList: {},
  centerEntranceList: {},
  channelFoldData: StorageManager.getInstance().get(storageKey.getChannelFoldDataKey()) ?? {},
  topicList: {},
  abTestReportInfoMap: {},
  welcomeGroupInfoMap: {},
  firstJoinMap: {},
};

export default state;
